module.exports = __webpack_public_path__ + "static/iatf-2024-f784dfff0d343bf26031f5fc93809df1.jpg";